import React from 'react';

import classNames from 'classnames';
import { ICON_POSITION } from '../../../../../constant/enums';

export interface IProps extends React.PropsWithChildren {
  border?: boolean;
  className?: string;
  padding?: string;
  position?: ICON_POSITION.Left | ICON_POSITION.Right;
}

const ClickFieldIcon: React.FC<IProps> = ({ children, border, className, padding, position }) => {
  const computedClassName = React.useMemo<string>(() => {
    return classNames('absolute inset-y-0 flex items-center border-gray-300 px-3', className, {
      'left-0': position == ICON_POSITION.Left,
      'right-0': position == ICON_POSITION.Right,
      'border-l-2': border && position == ICON_POSITION.Right,
      'border-r-2': border && position == ICON_POSITION.Left
    });
  }, [border, className, padding, position]);

  return (
    <span tabIndex={-1} className={computedClassName}>
      {children}
    </span>
  );
};

export default ClickFieldIcon;
